import {http} from '@/helpers/http-helper';

export const deleteUnlinkedMember = (id) => {
    return new Promise((resolve, reject) => {
        const url = 'unlinked-member/' + id;
        http.delete(url)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const createUnlinkedMember = (
    memberId,
    nif,
    name,
    surname,
    sex,
    birthday,
    email,
    phone
) => {
    return new Promise((resolve, reject) => {
        const url = 'unlinked-member';
        http.post(url, {
            memberId,
            nif,
            name,
            surname,
            sex,
            birthday,
            email,
            phone
        })
            .then((response) => {
                if (response.status === 201) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const updateUnlinkedMember = (
    id,
    nif,
    name,
    surname,
    sex,
    birthday,
    email,
    phone
) => {
    return new Promise((resolve, reject) => {
        const url = 'unlinked-member/' + id;
        http.post(url, {
            nif,
            name,
            surname,
            sex,
            birthday,
            email,
            phone
        })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};